import ImageCropperModal from './utils/imagecropper';

class EventImages {
    constructor() {

        this.form = document.getElementById("event-images");

        this.translations = {
            confirmRemove: this.form?.dataset.msgConfirmRemove || 'Are you sure you want to remove this image?',
            maxImages: this.form?.dataset.msgMaxImages || 'The maximum number of files allowed is three',
            maxSize: this.form?.dataset.msgMaxSize || 'Image size cannot be larger than 3 MB',
            invalidFileType: this.form?.dataset.msgInvalidFileType || 'Only JPG and PNG files are allowed'
        };

        this.language = this.form?.dataset.language;
        this.addButton = this.form?.querySelector("#event-images-add");
        this.list = this.form?.querySelector("#event-images-list");
        this.removeButtons = this.form?.querySelectorAll(".event-images-remove");
        this.fileInput = this.form?.querySelectorAll('file-input');

        this.cropperModal = new ImageCropperModal();
        this.bindEvents();
    }

    bindEvents() 
    {
        if (this.addButton) this.addButton.addEventListener("click", this.handleAddImage.bind(this));
        if (this.list) this.list.addEventListener("click", this.handleRemoveImage.bind(this));
        if (this.list) this.list.addEventListener("click", this.handleUploadImage.bind(this));
    }

    handleAddImage(e) {
        if (this.list.getElementsByTagName('li').length < 3) {
            this.renderImage(this.language);
        }
        else {
            alert(this.translations.maxImages);
        }
    }

    handleRemoveImage(e) {
        if (e.target.classList.contains('event-images-remove')) {
            e.preventDefault();
            
            const listItem = e.target.closest('li');
            if (listItem) {
                if (confirm(this.translations.confirmRemove)) {
                    listItem.remove();
                }
            }
        }
    }

    handleUploadImage(e) {
        if (e.target.classList.contains('upload-btn')) {
            const uploadButton = e.target.nextElementSibling;
            uploadButton.click();
            uploadButton.removeEventListener('change', this.fileUploadHandler);
            uploadButton.addEventListener('change', (e) => {
                if (e.target.files && e.target.files[0]) {

                    const file = e.target.files[0];
                    const fileType = file.type.toLowerCase();

                    if (!['image/jpeg', 'image/jpg', 'image/png'].includes(fileType)) {
                        alert(this.translations.invalidFileType);
                        return;
                    }

                    if (file.size > 3000000) {
                        alert(this.translations.maxSize)
                    } else {
                        const reader = new FileReader();
                        const previewImage = e.target.parentElement.getElementsByTagName('img')[0];
                        
                        reader.onload = (e) => {
                            this.cropperModal.open(e.target.result, previewImage);
                            previewImage.setAttribute('data-asset-id', '');
                        };
                        
                        reader.readAsDataURL(e.target.files[0]);
                    }

                    uploadButton.value = '';
                }
            });
        }
    }

    async renderImage(language) {
        const response = await fetch('/actions/events/events/render-image', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value
            },
            body: JSON.stringify({
                language: language
            })
        });

        const result = await response.text();
        this.list.insertAdjacentHTML('beforeend', result);

        this.removeButtons = this.form?.querySelectorAll(".event-images-remove");
    }

    async generateFormData(formData) {
        const images = await Promise.all(
            Array.from(this.list.querySelectorAll('li')).map(async li => {
                const imageInput = li.querySelector('input[type="file"]');
                const imgTag = li.getElementsByTagName('img')[0];
                const imageFile = imgTag?.getAttribute('src');
                let fileBase64 = '';
    
                if (imageFile) {
                    try {
                        const blob = await this.getBlobFromUrl(imageFile);
                        const file = new File([blob], 'example.jpg', { type: blob.type });
                        fileBase64 = await this.toBase64(file)
                    } catch (error) {
                        console.error('Error fetching or converting image:', error);
                    }
                }
    
                return {
                    id: li.dataset.id,
                    caption: li.querySelector('input[type="text"]').value,
                    file: btoa(unescape(encodeURIComponent(fileBase64))),
                    assetId: imgTag.dataset.assetId
                };
            })
        );
    
        images.forEach((image, index) => {
            formData.append(`images[${index}][caption]`, image.caption);
            formData.append(`images[${index}][assetId]`, image.assetId);
            
            if (image.file) {
                formData.append(`images[${index}][image]`, image.file);
            }
        });
    }

    async getBlobFromUrl(blobUrl) {
        try {
            const response = await fetch(blobUrl);
            
            if (!response.ok) {
                throw new Error(`Failed to fetch Blob. Status: ${response.status}`);
            }
            
            const blob = await response.blob();
            return blob;
        } catch (error) {
            console.error('Error fetching Blob:', error);
            throw error;
        }
    }

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });
}

const initEventImages = () => {
    if (document.getElementById("event-images")) {
        return new EventImages();
    }
    return null;
};

export default initEventImages;

window.eventImages = initEventImages;